import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Description = ({ text, isDangerously = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 100;

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const displayText = isExpanded ? text : `${text.substring(0, maxLength)}`;
  const showButton = text.length > maxLength;
  return (
    <div>
      {isDangerously ? (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: displayText
            }}
          />
          {showButton && (
            <a style={{ color: '#000000', cursor: 'pointer' }} onClick={toggleExpansion}>
              {isExpanded ? ' Read Less' : ' Read More'}
            </a>
          )}
        </>
      ) : (
        <>
          <p>
            {displayText}
            {showButton && (
              <a style={{ color: '#000000', cursor: 'pointer' }} onClick={toggleExpansion}>
                {isExpanded ? ' Read Less' : ' Read More'}
              </a>
            )}
          </p>
        </>
      )}
    </div>
  );
};

Description.propTypes = {
  isDangerously: PropTypes.bool,
  text: PropTypes.string.isRequired
};

export default Description;
